import { Avatar as AntAvatar } from "antd";
import type { AvatarProps as AntAvatarProps } from "antd";
import type { AvatarGroupProps } from "antd/es/avatar/AvatarGroup";
import { FC } from "react";

export type AvatarProps = AntAvatarProps & {
  name?: string;
};

export type { AvatarGroupProps };

/** @deprecated Please use `AvatarGroupProps` */
export type GroupProps = AvatarGroupProps;

type CompoundedComponent = FC<AvatarProps> & {
  Group: typeof AntAvatar.Group;
};

const getAvatarName = (name?: string) => {
  if (!name) return undefined;

  const words = name.trim().split(/\s+/);

  if (words.length === 1) {
    return words[0].charAt(0).toUpperCase();
  }

  return `${words[0].charAt(0)}${words[words.length - 1].charAt(0)}`.toUpperCase();
};

const InternalAvatar: FC<AvatarProps> = ({ name, children, ...props }) => {
  return <AntAvatar {...props}>{children ?? getAvatarName(name)}</AntAvatar>;
};

InternalAvatar.displayName = "CommonAvatar";

export const CommonAvatar = InternalAvatar as CompoundedComponent;
